import { render, staticRenderFns } from "./Role.tab.vue?vue&type=template&id=3323ae18&"
import script from "./Role.tab.vue?vue&type=script&lang=ts&"
export * from "./Role.tab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports